import React from 'react'
import ComingSoon from '../../pages/ComingSoon';

const ManagementSummury = () => {
  return (
    <div className=''>
        <ComingSoon />
    </div>
  )
}

export default ManagementSummury;
